import type { TypeSTTConfigForm } from '@intone/shared';
import {
  LanguageField,
  PhraseListField,
  ProfanityFilterField,
  ExplicitPunctuationField,
} from './Fields';

export type Props = {
  currentConfig: TypeSTTConfigForm;
  updateConfig: (field: keyof TypeSTTConfigForm, value: any) => void;
};

export function AzureAsrFields({ currentConfig, updateConfig }: Props) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4 items-start">
        <LanguageField value={currentConfig.language} onUpdate={(value) => updateConfig('language', value)} />
        <PhraseListField
          value={currentConfig.phrase_list}
          onUpdate={(value) => updateConfig('phrase_list', value)}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <ProfanityFilterField
          value={currentConfig.profanity_filter}
          onUpdate={(value) => updateConfig('profanity_filter', value)}
        />
        <ExplicitPunctuationField
          value={currentConfig.explicit_punctuation}
          onUpdate={(value) => updateConfig('explicit_punctuation', value)}
        />
      </div>
    </div>
  );
}